import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white" }
const _hoisted_2 = { class: "mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 py-6 md:px-6 md:py-8" }
const _hoisted_3 = { class: "relative overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm" }
const _hoisted_4 = { class: "relative px-6 py-6 md:px-10 md:py-8" }
const _hoisted_5 = { class: "mt-2 flex flex-col gap-4 md:flex-row md:items-end md:justify-between" }
const _hoisted_6 = { class: "font-display text-3xl leading-tight text-slate-900 md:text-4xl" }
const _hoisted_7 = { class: "mt-2 max-w-2xl text-sm leading-6 text-slate-600" }
const _hoisted_8 = { class: "text-sm font-semibold text-slate-500 md:text-right" }
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = {
  class: "sr-only",
  for: "instrument-search"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-amber-800 shadow-sm"
}
const _hoisted_13 = {
  key: 1,
  class: "rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-emerald-700 shadow-sm"
}
const _hoisted_14 = {
  key: 2,
  class: "rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-rose-700 shadow-sm"
}
const _hoisted_15 = {
  key: 3,
  class: "rounded-3xl bg-white px-6 py-8 text-slate-500 shadow-sm"
}
const _hoisted_16 = {
  key: 4,
  class: "space-y-6"
}
const _hoisted_17 = {
  key: 0,
  class: "rounded-3xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center text-slate-500 shadow-sm"
}
const _hoisted_18 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_19 = {
  key: 2,
  class: "flex justify-end"
}

import { computed, onMounted, ref } from "vue";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import Cards from "@/components/Cards.vue";
import ServiceVerzoekModal from "@/components/ServiceVerzoekModal.vue";
import { instrumentI } from "@/interfaces/interfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'InstrumentenPage',
  setup(__props) {

const supportedLanguages = ["nl", "fr", "en", "de"] as const;

const search = ref("");
const error = ref("");
const notice = ref("");
const infoMessage = ref("");
const loading = ref(true);
const language = ref("nl");
const instrumenten = ref([] as Array<instrumentI>);
const verkooprelatieNaam = ref("");
const initConfig = ref("");
const showModal = ref(false);
const selectedInstrument = ref<instrumentI | null>(null);

const translations: { [key: string]: { [key: string]: string } } = {
  nl: {
    titel: "Instrumenten in gebruik",
    subtitle: "Bekijk uw installed base, dien een serviceverzoek in of markeer instrumenten als niet meer in gebruik.",
    search: "Zoeken op instrument of serienummer...",
    insturen: "Insturen",
    geenInstrumenten: "Geen instrumenten gevonden.",
    laadstatus: "Instrumenten worden geladen...",
    foutApi: "Geen init_config parameter meegegeven.",
    foutOphalen: "Er is een fout opgetreden bij het ophalen van uw instrumenten.",
    succesBatch: "De geselecteerde instrumenten zijn bijgewerkt.",
    succesService: "Het serviceverzoek is ingediend.",
  },
  fr: {
    titel: "Instruments en service",
    subtitle: "Consultez votre parc installé, soumettez une demande de service ou marquez des instruments comme hors service.",
    search: "Rechercher par instrument ou numéro de série...",
    insturen: "Envoyer",
    geenInstrumenten: "Aucun instrument trouvé.",
    laadstatus: "Chargement des instruments...",
    foutApi: "Aucun paramètre init_config fourni.",
    foutOphalen: "Une erreur s'est produite lors du chargement de vos instruments.",
    succesBatch: "Les instruments sélectionnés ont été mis à jour.",
    succesService: "La demande de service a été envoyée.",
  },
  en: {
    titel: "Instruments in use",
    subtitle: "Review your installed base, submit a service request, or mark instruments as no longer in use.",
    search: "Search by instrument or serial number...",
    insturen: "Submit",
    geenInstrumenten: "No instruments found.",
    laadstatus: "Loading instruments...",
    foutApi: "No init_config parameter provided.",
    foutOphalen: "An error occurred while loading your instruments.",
    succesBatch: "The selected instruments have been updated.",
    succesService: "The service request has been submitted.",
  },
  de: {
    titel: "Instrumente in Gebrauch",
    subtitle: "Prüfen Sie Ihre installierte Basis, senden Sie eine Serviceanfrage oder markieren Sie Instrumente als außer Betrieb.",
    search: "Nach Instrument oder Seriennummer suchen...",
    insturen: "Einsenden",
    geenInstrumenten: "Keine Instrumente gefunden.",
    laadstatus: "Instrumente werden geladen...",
    foutApi: "Kein init_config-Parameter angegeben.",
    foutOphalen: "Beim Laden Ihrer Instrumente ist ein Fehler aufgetreten.",
    succesBatch: "Die ausgewählten Instrumente wurden aktualisiert.",
    succesService: "Die Serviceanfrage wurde eingereicht.",
  },
};

const setLanguage = (value: string | null) => {
  if (value && supportedLanguages.includes(value as (typeof supportedLanguages)[number])) {
    language.value = value;
  } else {
    language.value = "nl";
  }
};

const t = (key: string) => {
  return (translations[language.value] || translations.nl)[key];
};

const buildRequestUrl = () => {
  if (!initConfig.value) {
    return "";
  }

  const params = new URLSearchParams(window.location.search);
  params.delete("init_config");
  const query = params.toString();
  if (!query) {
    return initConfig.value;
  }

  const separator =
    initConfig.value.includes("?") &&
    !initConfig.value.endsWith("?") &&
    !initConfig.value.endsWith("&")
      ? "&"
      : initConfig.value.includes("?")
        ? ""
        : "?";

  return `${initConfig.value}${separator}${query}`;
};

const requestUrl = computed(() => buildRequestUrl());

const filteredInstrumenten = computed(() => {
  const term = search.value.trim().toLowerCase();
  if (!term) {
    return instrumenten.value;
  }

  return instrumenten.value.filter(
    (instrument) =>
      instrument.Serienummer.toLowerCase().includes(term) ||
      instrument.Instrumentnaam.toLowerCase().includes(term)
  );
});

const hasMarkedInstruments = computed(() => {
  return instrumenten.value.some((instrument) => instrument.Niet_meer_in_gebruik);
});

const openServiceVerzoek = (instrument: instrumentI) => {
  error.value = "";
  notice.value = "";
  selectedInstrument.value = instrument;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedInstrument.value = null;
};

const handleServiceVerzoekSubmitted = () => {
  notice.value = t("succesService");
  if (selectedInstrument.value) {
    selectedInstrument.value.serviceVerzoekInstuurdatum = new Date().toISOString();
  }
};

const toggleUitGebruik = (instrument: instrumentI) => {
  error.value = "";
  notice.value = "";
  instrument.Niet_meer_in_gebruik = !instrument.Niet_meer_in_gebruik;
};

const submitUitGebruik = () => {
  const markedInstrumenten = instrumenten.value
    .filter((instrument) => instrument.Niet_meer_in_gebruik)
    .map((instrument) => ({
      Serienummer: instrument.Serienummer,
      Itemcode: instrument.Itemcode,
      Niet_meer_in_gebruik: true,
    }));

  if (markedInstrumenten.length === 0) {
    return;
  }

  if (!requestUrl.value) {
    error.value = t("foutApi");
    return;
  }

  error.value = "";
  notice.value = "";
  Nprogress.start();

  fetch(requestUrl.value, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      type: "niet_meer_in_gebruik",
      instrumenten: markedInstrumenten,
    }),
  })
    .then(async (response) => {
      if (!response.ok) {
        const data = await response.json().catch(() => undefined);
        throw new Error((data && data.message) || response.statusText);
      }

      instrumenten.value = instrumenten.value.filter(
        (instrument) => !instrument.Niet_meer_in_gebruik
      );
      notice.value = t("succesBatch");
    })
    .catch((err) => {
      error.value = err instanceof Error ? err.message : t("foutOphalen");
    })
    .finally(() => {
      Nprogress.done();
    });
};

const fetchData = () => {
  Nprogress.start();
  const params = new URLSearchParams(window.location.search);
  initConfig.value = (params.get("init_config") || "").trim();

  if (!initConfig.value) {
    error.value = t("foutApi");
    loading.value = false;
    Nprogress.done();
    return;
  }

  fetch(requestUrl.value, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(res.statusText);
      }
      return res.json();
    })
    .then((json) => {
      setLanguage(json.Sitelanguage || navigator.language?.split("-")[0]);
      if (json.message) {
        infoMessage.value = json.message;
      }

      instrumenten.value = json.metadata?.instrumenten || [];
      if (instrumenten.value.length > 0) {
        verkooprelatieNaam.value = instrumenten.value[0].Naam_verkooprelatie || "";
      }
    })
    .catch((err) => {
      error.value = err instanceof Error ? err.message : t("foutOphalen");
    })
    .finally(() => {
      Nprogress.done();
      loading.value = false;
    });
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 w-1.5 bg-gullimex-orange" }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute -top-24 -right-24 h-64 w-64 rounded-full bg-gullimex-orange/10 blur-3xl" }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-[0.3em] text-gullimex-orange" }, " Installed Base Portal ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(t("titel")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(t("subtitle")), 1)
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(verkooprelatieNaam.value || "Gullimex"), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(t("search")), 1),
            _withDirectives(_createElementVNode("input", {
              id: "instrument-search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              type: "search",
              class: "w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-800 shadow-inner outline-none transition focus:border-gullimex-orange focus:bg-white",
              placeholder: t('search')
            }, null, 8, _hoisted_11), [
              [_vModelText, search.value]
            ])
          ])
        ])
      ]),
      (infoMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(infoMessage.value), 1))
        : _createCommentVNode("", true),
      (notice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(notice.value), 1))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(t("laadstatus")), 1))
        : (_openBlock(), _createElementBlock("section", _hoisted_16, [
            (filteredInstrumenten.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(t("geenInstrumenten")), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredInstrumenten.value, (instrument) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: instrument.Serienummer
                    }, [
                      _createVNode(Cards, {
                        instrument: instrument,
                        language: language.value,
                        mode: "instrumenten",
                        "onUpdate:Niet_meer_in_gebruik": ($event: any) => (toggleUitGebruik(instrument)),
                        onServiceverzoek: ($event: any) => (openServiceVerzoek(instrument))
                      }, null, 8, ["instrument", "language", "onUpdate:Niet_meer_in_gebruik", "onServiceverzoek"])
                    ]))
                  }), 128))
                ])),
            (hasMarkedInstruments.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "rounded-2xl bg-gullimex-orange px-5 py-3 font-semibold text-white shadow-sm transition hover:bg-amber-500",
                    onClick: submitUitGebruik
                  }, _toDisplayString(t("insturen")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    (showModal.value && selectedInstrument.value)
      ? (_openBlock(), _createBlock(ServiceVerzoekModal, {
          key: 0,
          instrument: selectedInstrument.value,
          language: language.value,
          "request-url": requestUrl.value,
          onClose: closeModal,
          onSubmitted: handleServiceVerzoekSubmitted
        }, null, 8, ["instrument", "language", "request-url"]))
      : _createCommentVNode("", true)
  ]))
}
}

})